// extracted by mini-css-extract-plugin
module.exports = {"selectBox":"MakeMultiSelect_selectBox__opQaj","make":"MakeMultiSelect_make__QPDWs"};